function orderByName(items: any, label: any, type?: string) {
  if (!items?.length) return;

  if (type === "number") {
    return items?.sort(function (a: any, b: any) {
      if (a[label] > b[label]) {
        return 1;
      }
      if (a[label] < b[label]) {
        return -1;
      }
      // a must be equal to b
      return 0;
    });
  }

  return items?.sort(function (a: any, b: any) {
    if (a[label]?.toLowerCase() > b[label]?.toLowerCase()) {
      return 1;
    }
    if (a[label]?.toLowerCase() < b[label]?.toLowerCase()) {
      return -1;
    }
    // a must be equal to b
    return 0;
  });
}

export { orderByName };
